const EDITABLE_NODE_DATA_KEYS = ["config", "storage", "required"];

const cloneValue = (value) => {
  if (value === undefined || value === null || typeof value !== "object") {
    return value;
  }

  return JSON.parse(JSON.stringify(value));
};

export const mergeEditableNodeData = (currentData = {}, patch = {}) => {
  const nextData = cloneValue(currentData) || {};

  EDITABLE_NODE_DATA_KEYS.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(patch, key)) {
      nextData[key] = cloneValue(patch[key]);
    }
  });

  return nextData;
};
